import type { Mutation, MutationOp } from '../mutations';

/** RESERVED_KEYS (v0.1a): set by the appliers; a builder that puts them in values is a bug. */
const APPLIER_KEYS = ['id', 'userId', 'createdAt', 'updatedAt', 'deletedAt', 'clock'] as const;

/** Everything a builder needs from the outside world, so builders stay pure. */
export interface BuildCtx {
  now: string; // ISO UTC instant
  tz: string; // IANA zone, e.g. 'Asia/Manila'
  newId: () => string;
}

export type SpendResult<T, E extends string> = ({ ok: true } & T) | { ok: false; error: E };

export function spendingMutation(
  ctx: BuildCtx,
  table: string,
  op: MutationOp,
  rowId: string,
  values?: Record<string, unknown>,
  opts: { ifAbsent?: true } = {},
): Mutation {
  // Built directly (not with insertMutation/updateMutation) so tests control ids via ctx.newId.
  // Keys are Drizzle property names.
  for (const k of APPLIER_KEYS) {
    if (values && k in values) throw new Error(`Mutation values must not include '${k}'`);
  }
  return {
    id: ctx.newId(),
    table,
    op,
    rowId,
    ...(values ? { values } : {}),
    at: ctx.now,
    source: 'spending',
    ...(opts.ifAbsent ? { ifAbsent: true as const } : {}),
  };
}
